/**
 * Intent.ai tracking helper
 * Tracks events using the Intent.ai pixel
 */
// export const trackIntentEvent = (eventName) => {
// 	if (typeof window !== 'undefined' && window.intentData) {
// 		window.intentData = window.intentData || [];
// 		window.intentData.push(["692440e8d1c7ad71ffadafe8", eventName]);
// 	}
// };

/**
 * Intent.ai tracking helper
 * Tracks events using the Intent.ai pixel
 */
export const trackIntentEvent = (eventName) => {
	if (typeof window !== 'undefined' && window.intentData) {
		window.intentData = window.intentData || [];
		window.intentData.push(["692440e8d1c7ad71ffadafe8", eventName]);
		console.log('✅ Intent.ai event tracked:', eventName, window.intentData);
	} else {
		console.warn('⚠️ Intent.ai not loaded or window not available');
	}
};